<span>{{ message || "Something went wrong." }}</span> 
<button class="snack-bar-button" (click)="refresh()" mat-button>REFRESH</button>